import { Store } from 'src/store/index';

const getProductBundleSelectedProducts = (store: Store) => store.productBundle.selectedProducts;

export default getProductBundleSelectedProducts;
